(function () {
    var cfg = window.DOPLINE_HOTELS_LOADER;
    if (!cfg) return;

    var list = document.querySelector('[data-results-list]');
    if (!list) return;

    function retryUrl() {
        var url = new URL(window.location.href);
        url.searchParams.delete('_hs');
        return url.toString();
    }

    function showError(msg) {
        list.innerHTML =
            '<div class="dl-card dopline-search-error">' +
            '<p class="dopline-search-error__msg">' + msg + '</p>' +
            '<a class="dl-btn dl-btn--accent" href="' + retryUrl() + '">Попробовать снова</a>' +
            '</div>';
    }

    async function fetchPage(offset) {
        var url = new URL(cfg.api, window.location.origin);
        url.searchParams.set('_hs',    cfg.hs);
        url.searchParams.set('lang',   cfg.lang || 'ru');
        url.searchParams.set('offset', String(offset));
        url.searchParams.set('limit',  String(cfg.limit || 20));

        var res = await fetch(url.toString(), { headers: { 'Accept': 'application/json' } });
        if (!res.ok) throw new Error('hotels-page: HTTP ' + res.status);

        var data = await res.json();
        if (!data.success) throw new Error(data.message || 'hotels-page failed');
        return data.data; // { html, total, offset, has_more }
    }

    function appendHtml(html) {
        if (!html) return;
        var tmp = document.createElement('div');
        tmp.innerHTML = html;
        while (tmp.firstChild) {
            list.appendChild(tmp.firstChild);
        }
    }

    async function loadAll() {
        var limit  = cfg.limit || 20;
        var offset = 0;
        var total  = 0;
        var firstPage = true;

        try {
            while (true) {
                var page = await fetchPage(offset);
                total = page.total;

                // Clear skeleton on first chunk arrival.
                if (firstPage) {
                    list.innerHTML = '';
                    firstPage = false;

                    // Initialize map with all hotel markers included in the first response.
                    if (page.markers && window.DoplineResultsMap && window.DoplineResultsMap.reinit) {
                        window.DoplineResultsMap.reinit(page.markers);
                    }
                }

                appendHtml(page.html);

                if (!page.has_more) break;
                offset += limit;
            }
        } catch (err) {
            showError('Не удалось загрузить результаты поиска. Попробуйте ещё раз.');
            return;
        }

        if (!total) {
            list.innerHTML = '<div class="dl-card dopline-empty">По вашему запросу ничего не найдено.</div>';
            return;
        }

        // Update found-count badge.
        var foundEl = document.querySelector('[data-found-count]');
        if (foundEl) foundEl.textContent = String(total);

        // Notify results.js that hotel cards are ready in the DOM.
        document.dispatchEvent(new CustomEvent('dopline:hotels-ready'));
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', loadAll);
    } else {
        loadAll();
    }
})();
